module.exports = __webpack_public_path__ + "assets/no-code-tag.d2293745.svg";